const dateOptions = {
  month: '2-digit',
  day: '2-digit',
  year: '2-digit'
};

export function makeLocalToUTC(val) {
  if (!val) return val;
  const d = new Date(val);
  return new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes()
    )
  );
}

export function makeUTCtoLocal(val) {
  if (!val) return val;
  const d = new Date(val);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

export function makeUTCDateStr(val) {
  if (!val) return val;
  const d = new Date(val);
  const [month, date, year] = [
    (d.getUTCMonth() + 1).toString(),
    d.getUTCDate().toString(),
    d.getUTCFullYear()
  ];
  const displayMonth = `${month.length === 1 ? '0' : ''}${month}`;
  const displayDate = `${date.length === 1 ? '0' : ''}${date}`;
  return `${year}-${displayMonth}-${displayDate}`;
}

export function makeLocalDateStr(val, options = {}) {
  if (!val) return val;
  const dateObj = new Date(val);
  return dateObj.toLocaleDateString([], { ...dateOptions, ...options });
}

export function makeValidDateBody(val) {
  const res = val
    ? { String: val.toISOString(), Valid: true }
    : { String: '', Valid: false };
  return res;
}
